export default __webpack_public_path__ + "1e25fb3d45cf9d63d17168e5f2ba7fe8.svg";